import React, { Component } from "react";

// import Immutable from 'immutable';
// import { connect } from 'react-redux';
// import config from 'config/api'
import clsx from "clsx";
// import withWidth from '@material-ui/core/withWidth';
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";

import BlockTitle from "components/UI/BlockTitle";
import { withRouter } from "react-router-dom";

import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
// import IconUp from '@material-ui/icons/KeyboardArrowUp';
// import IconDown from '@material-ui/icons/KeyboardArrowDown';

import { tercaryColor, primaryColor } from "helpers/colors";

// const AF_KEY = 'home';

const styles = (theme) => {
  return {
    root: {
      // padding: "0 0 20px 0",
    },
    darker: {
      backgroundColor: primaryColor,
    },
    inline: {
      display: "inline-block",
    },
    title: {
      // border: "1px " + primaryColor + " solid",
      // padding: "5px 0",
      padding: 0,
      [theme.breakpoints.down("sm")]: {
        marginBottom: 20,
      },
    },
    button: {
      marginLeft: 5,
      marginRight: 5,
      [theme.breakpoints.down("sm")]: {
        marginBottom: 5,
      },
    },
  };
};

class HomeHelp extends Component {
  _goRedir(url) {
    const { history } = this.props;
    history.push(url);
  }
  render() {
    const { classes, style } = this.props;

    return (
      <Box
        py={4}
        px={8}
        mb={6}
        style={style}
        align="center"
        bgcolor="primary.main"
        className={classes.root}
      >
        <Grid
          container={true}
          spacing={2}
          alignItems="center"
          justify="space-around"
        >
          <Grid item={true} sm={12} md={true} lg={7}>
            <Box align="middle" className={classes.title}>
              <Typography variant="h2" style={{ color: "#fff" }}>
                Besoin d’aide pour utiliser l’outil de webconférence ?
              </Typography>
            </Box>
          </Grid>
          <Grid
            item={true}
            sm={12}
            md={6}
            lg={5}
            container={true}
            spacing={2}
            alignItems="center"
            justify="space-around"
          >
            <span className={classes.inline}>
              <Button
                color="secondary"
                className={classes.button}
                onClick={(e) => {
                  e.preventDefault();
                  this._goRedir("/help");
                }}
              >
                Voir notre rubrique Aide
              </Button>
              <Button
                className={clsx(classes.button, classes.darker)}
                onClick={(e) => {
                  e.preventDefault();
                  this._goRedir("/contact");
                }}
              >
                Nous contacter
              </Button>
            </span>
          </Grid>
        </Grid>
      </Box>
    );
  }
}

export default withRouter(withStyles(styles)(HomeHelp));



// WEBPACK FOOTER //
// ./src/components/Home/HomeHelp.jsx